
import BasicCard from "../../pages/BasicCard";

import Dummylayout from "../../pages/Dummylayout";
import AnnouncemenForm from "./AnnouncementForm";

function AnnouncementFormMain() {
    return (
        <>
        {/* <MainLayout/> */}
           <div> <Dummylayout/></div>
    
<div className="mx-5 pl-5">
            <BasicCard>
                <AnnouncemenForm/>
               
            </BasicCard>
            </div>
        </>
    )
}
export default AnnouncementFormMain;